<div class="block">
  <svg class="mx-auto block" [attr.width]="responsiveWidth" [attr.height]="calculatedHeight"
    [attr.viewBox]="'0 0 ' + responsiveWidth + ' ' + calculatedHeight" style="overflow: visible">
    <path [attr.d]="trackPath" [attr.stroke-width]="size()" [attr.stroke]="background()" fill="none"
      stroke-linecap="butt">
    </path>

    <path [attr.d]="valuePath" [attr.stroke-width]="size()" [attr.stroke]="color()" fill="none" stroke-linecap="butt">
    </path>

    <foreignObject [attr.x]="0"
      [attr.y]="widthInRem() <= 12 ? (calculatedHeight * 5 / 7) -10 : (calculatedHeight/2 -10)"
      [attr.width]="responsiveWidth" [attr.height]="calculatedHeight/2" pointer-events="none">
      <div xmlns="http://www.w3.org/1999/xhtml"
        class="flex flex-col items-center w-full h-full justify-start overflow-visible">
        <p class="text-zen font-medium mb-1.5" [style.fontSize.px]="widthInRem() + 10">
          {{displayValue()}}{{ hasDisplayOverride() ? '' : '%' }}</p>
      </div>
    </foreignObject>
  </svg>
  <div class="w-full flex flex-row justify-center truncate text-center -mt-2.5 z-10">
    <ng-content></ng-content>
  </div>
</div>